import { MouseEvent, useState } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import Image from "next/image";
import Head from "next/head";
import { useNotifications } from "contexts/NotificationContext";
import Icon, { ICONS } from "components/common/Icons";
import SearchModal from "components/templates/common/Detail/SearchModal";
import { track } from "lib/analytics/core/client";
import { TrackedLogo } from "lib/analytics/react/link";

const TopBar = ({
  searchModal,
  setSearchModal,
  isServerErrorPage = false,
}: any) => {
  // const { newNotification } = useNotifications();
  const router = useRouter();
  // const [searchModal, setSearchModal] = useState(false);

  const handleMainPage = (e: MouseEvent<HTMLAnchorElement>) => {
    sessionStorage.removeItem(`main-scrollPosition`);
    sessionStorage.removeItem(`search-scrollPosition`);
  };

  if (
    router.pathname !== "/" &&
    router.pathname !== "/portfolio" &&
    router.pathname !== "/service" &&
    router.pathname !== "/watchlist" &&
    router.pathname !== "/signup" &&
    router.pathname !== "/404" &&
    router.pathname !== "/search" &&
    !router.pathname.startsWith("/keyword") &&
    !isServerErrorPage
  ) {
    return <></>;
  }
  return (
    <header className="fixed top-0 w-full z-30 bg-white h-16 border-b border-gray-100 py-[14px] pl-5 pr-[14px] ">
      {/* <Head>
        <link rel="Icon" href="/images/favicon.png" type="image/x-icon" />
        <title>Riskweather</title>
        <meta
          property="og:image"
          content="https://riskweather.io/images/favicon.png"
        />
        <meta
          property="og:description"
          content={
            router.locale === "ko"
              ? "투자 리스크의 기준 - 리스크웨더"
              : "Invest with Confidence, We've Got the Risks Covered"
          }
        />
        <meta name="description" content={"투자 리스크의 기준 - 리스크웨더"} />

        <meta property="og:title" content="Riskweather" />
      </Head> */}

      <div className="h-full mx-auto flex items-center justify-between w-full">
        {router.pathname !== "/signup" && (
          <TrackedLogo href="/" asTrace={true} onClick={handleMainPage}>
            <Image
              width={30}
              height={30}
              unoptimized
              src={`/images/header/headerLogo.svg`}
              alt="logo"
              className="cursor-pointer w-auto h-auto"
            />
          </TrackedLogo>
        )}

        {router.pathname !== "/login" &&
          router.pathname !== "/signup" &&
          !router.pathname.startsWith("/b2b") && (
            <section className="flex justify-center items-center gap-4">
              {/* <Image
              src={"/images/header/search.svg"}
              alt=""
              className="w-auto h-auto cursor-pointer"
              width={30}
              height={30}
              onClick={() => {
                router.push("/search-list");
              }}
            /> */}
              {/* <Image
              src={"/images/header/noti.svg"}
              alt=""
              className="w-auto h-auto cursor-pointer"
              width={30}
              height={30}
              onClick={() => {
                router.push("/alarm");
              }}
            /> */}

              {/* <div
                onClick={() => {
                  router.push("/alarm");
                }}
                className="cursor-pointer"
              >
                <Icon
                  name={newNotification ? ICONS.NOTI_ON : ICONS.NOTI_OFF}
                  height={30}
                  width={30}
                  fill="gray40"
                />
              </div> */}
              <div className="flex items-center gap-[2px]">
                <div
                  onClick={() => {
                    // 🔍 검색 버튼 클릭 이벤트 (SDK가 자동으로 intent_id 관리)
                    track("search_open", {
                      search_type: "unified", // 통합검색
                      source: "main_header", // 헤더에서 열림
                    });

                    setSearchModal((prev: any) => ({
                      search:
                        router.pathname === "/search"
                          ? router.query.query
                          : prev.search,
                      modalOpen: true,
                    }));
                  }}
                  className="cursor-pointer p-[6px]"
                >
                  <Icon
                    name={ICONS.SEARCH}
                    height={30}
                    width={30}
                    fill="gray40"
                  />
                </div>
                <div
                  onClick={() => {
                    router.push("/service");
                  }}
                  className="cursor-pointer p-[6px]"
                  data-gtm-id={"메인-서비스-버튼"}
                >
                  <Icon
                    name={ICONS.MENU}
                    height={30}
                    width={30}
                    fill="gray40"
                  />
                </div>
              </div>
            </section>
          )}
      </div>
      {/* {searchModal && <SearchModal setSearchModal={setSearchModal} />} */}
    </header>
  );
};

export default TopBar;
